import { Dialog, ButtonCallbacks } from '@/components/types/Dialog';

export const unlicensedDialog: Dialog = {
  title: 'upselling.expiredTrialTitle',
  dialogWidth: '60vw',
  maxWidth: '550px',
  buttonConfig: [
    {
      callbackID: ButtonCallbacks.ACTION,
      text: 'upselling.upgradeButton'
    }
  ]
};

export const expiringTrialDialog: Dialog = {
  title: 'upselling.soonExpiringTrialTitle',
  maxWidth: '700px',
  buttonConfig: [
    {
      callbackID: ButtonCallbacks.CANCEL,
      text: 'upselling.continue',
      outlined: true
    },
    {
      callbackID: ButtonCallbacks.ACTION,
      text: 'upselling.upgradeButton'
    }
  ]
};

export const freePlanActivationDialog: Dialog = {
  title: 'upselling.freePlan.title',
  maxWidth: '900px',
  buttonConfig: [
    {
      callbackID: ButtonCallbacks.CANCEL,
      text: 'common.cancel',
      outlined: true
    },
    {
      callbackID: ButtonCallbacks.ACTION,
      text: 'upselling.freePlan.submit'
    }
  ]
};
